import { render } from "./DescListView.vue?vue&type=template&id=798230c4&scoped=true"
import script from "./DescListView.vue?vue&type=script&lang=js"
export * from "./DescListView.vue?vue&type=script&lang=js"

import "./DescListView.vue?vue&type=style&index=0&id=798230c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798230c4"]])

export default __exports__